if (!customElements.get('bundle-variant-picker')) {
  customElements.define(
    'bundle-variant-picker',
    class BundleVariantPicker extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.onPickerChange = this.handlePickerChange.bind(this);
        this.onProductInfoChange = this.handleProductInfoChange.bind(this);
        this.onProductSubmit = this.handleProductSubmit.bind(this);

        this.addEventListener('change', this.onPickerChange);
        this.productInfo?.addEventListener('change', this.onProductInfoChange);
        this.productForm?.addEventListener('submit', this.onProductSubmit, true);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onPickerChange);
        this.productInfo?.removeEventListener('change', this.onProductInfoChange);
        this.productForm?.removeEventListener('submit', this.onProductSubmit, true);
      }

      get productForm() {
        return this.productInfo?.querySelector('form[is="product-form"]');
      }

      get submitButton() {
        return this.productForm?.querySelector('[type="submit"]');
      }

      handlePickerChange(event) {
        const optionInput = event.target.closest('[data-bundle-option] input[type="radio"]');
        if (!optionInput || !this.contains(optionInput)) return;

        const optionGroup = optionInput.closest('[data-bundle-option]');
        const selectedValue = optionGroup?.querySelector('[data-selected-value]');
        if (selectedValue) selectedValue.textContent = optionInput.value;
        this.updateComponentImage(optionGroup, optionInput.value);

        this.dataset.pending = 'true';
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-busy', 'true');
        }
      }

      updateComponentImage(optionGroup, optionValue) {
        const imageDataElement = optionGroup?.querySelector('[data-bundle-component-images]');
        const image = optionGroup?.querySelector('[data-bundle-component-image] img');
        if (!imageDataElement) return;

        try {
          const imageData = JSON.parse(imageDataElement.textContent);
          const selectedImage = imageData[optionValue] || imageData[String(optionValue || '').trim()];
          if (selectedImage?.url) {
            optionGroup.querySelectorAll('[data-bundle-component-link]').forEach((link) => {
              link.href = selectedImage.url;
            });
          }
          if (!image || !selectedImage?.src) return;

          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.loading = 'eager';
          image.src = selectedImage.src;
          image.alt = selectedImage.alt || '';
        } catch (error) {
          return;
        }
      }

      handleProductInfoChange(event) {
        if (!event.target.matches('form[is="product-form"] input[name="id"]')) return;
        window.setTimeout(() => this.finishVariantUpdate(event.target), 0);
      }

      handleProductSubmit(event) {
        const idInput = this.productForm?.querySelector('input[name="id"]');
        const selectedVariant = this.getSelectedVariant();
        const canAdd =
          this.dataset.pending !== 'true' &&
          selectedVariant?.available &&
          String(selectedVariant.id) === idInput?.value &&
          this.variantMatchesSelection(selectedVariant) &&
          !this.submitButton?.disabled;

        if (canAdd) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      getSelectedVariant() {
        const selectedVariantElement = this.querySelector('[data-selected-variant]');

        try {
          return JSON.parse(selectedVariantElement?.textContent || 'null');
        } catch (error) {
          return null;
        }
      }

      getSelectedOptionValues() {
        const variantSelects = this.querySelector('variant-selects');
        if (!variantSelects) return [];

        return Array.from(variantSelects.querySelectorAll('fieldset input:checked')).map((input) => input.value);
      }

      variantMatchesSelection(variant) {
        if (!Array.isArray(variant?.options)) return false;
        const selectedOptionValues = this.getSelectedOptionValues();

        return (
          variant.options.length === selectedOptionValues.length &&
          variant.options.every((value, index) => String(value) === selectedOptionValues[index])
        );
      }

      finishVariantUpdate(idInput) {
        const selectedVariant = this.getSelectedVariant();
        const variantMatches = selectedVariant && String(selectedVariant.id) === idInput.value;
        const selectionMatches = this.variantMatchesSelection(selectedVariant);

        if (!variantMatches || !selectionMatches) return;
        delete this.dataset.pending;
        this.submitButton?.removeAttribute('aria-busy');
      }
    }
  );
}
